<style>
    p {
        font-size: 14px;
    }
</style>
<mat-card>
    <mat-card-header>
        <mat-card-title>Điều Khoản<br>
        </mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <div #focus tabindex="-1" style="height: calc(100vh - 14rem); overflow-y: scroll; border: 1px solid lightgrey;"
            class="my-3 px-3 py-3">
            <p>
            <strong>Điều 1. Phạm vi dịch vụ cung cấp</strong>
            <br>
            Viettel cung cấp cho Khách hàng dịch vụ ngân hàng điện tử thông qua website chính thức của
            Viettel với địa chỉ tên miền http://www.vietcombank.com.vn, thư điện tử và dịch vụ nhắn tin thực
            hiện trên điện thoại di động (sau đây gọi tắt là “Dịch vụ”), bao gồm:
            <br>
            &nbsp;&nbsp;&nbsp;&nbsp;- Truy vấn thông tin: tài khoản tiền gửi, tài khoản tiền vay, thông tin thẻ tín dụng, tỷ giá, lãi suất...
            <br>
            &nbsp;&nbsp;&nbsp;&nbsp;- Thanh toán hóa đơn mua hàng hóa, dịch vụ với nhà cung cấp có liên kết với Viettel.
            <br>
            &nbsp;&nbsp;&nbsp;&nbsp;- Các dịch vụ Ngân hàng điện tử khác mà Viettel cung cấp từng thời kỳ.
            </p>

            <p><strong>Điều 2. Cam kết của Khách hàng</strong>
            <br>
            2.1. Thực hiện các hướng dẫn về Dịch vụ do Viettel cung cấp.
            <br>
            2.2. Trừ khi đã thông báo trước cho Viettel theo khoản mục 6.3 và 6.8 tại Điều 6 của Hợp đồng
            này, Khách hàng thừa nhận rằng bất cứ hành động truy cập nào vào dịch vụ Ngân hàng điện tử bằng
            tên truy cập với đúng mật khẩu truy cập và/hoặc các yếu tố định danh khác do Viettel cấp cho
            Khách hàng đều được coi là Khách hàng truy cập.
            <br>
            2.3. Đồng ý cung cấp tất cả thông tin mà Viettel yêu cầu phục vụ cho việc cung ứng dịch vụ. Khách
            hàng đảm bảo rằng tất cả các thông tin cung cấp cho Viettel là chính xác, đầy đủ, trung thực và
            cập nhật.
            <br>
            2.4. Trong trường hợp sử dụng dịch vụ Ngân hàng điện tử qua điện thoại di động, thư điện tử, Khách hàng
            đồng ý rằng:
            <br>
            &nbsp;&nbsp;a) Thông báo ngay cho Viettel bất kỳ sự thay đổi gì liên quan đến địa chỉ thư điện tử, số điện thoại
            di động của mình (cho dù những thay đổi này phát sinh do việc thay đổi số điện thoại mới, hoặc việc
            ngừng sử dụng dịch vụ với nhà cung cấp, hoặc là do điện thoại di động của Khách hàng bị mất, hoặc vì
            bất kỳ lý do nào khác). Trừ khi nhận được thông báo của Khách hàng, Viettel sẽ tiếp tục cung cấp
            dịch vụ qua địa chỉ email hoặc số điện thoại di động mà Khách hàng đã đăng ký.
            <br>
            &nbsp;&nbsp;b) Tin nhắn được coi là đã gửi cho Khách hàng nếu việc gửi tin này đã được thực hiện bởi nhà cung cấp
            dịch vụ bất kể Khách hàng có thực sự nhận được tin nhắn hay không.
            <br>
            &nbsp;&nbsp;c) Viettel không đảm bảo tính bảo mật của bất kỳ thông tin hoặc tin nhắn của Ngân hàng điện
            tử và không chịu trách nhiệm về việc thông tin hoặc tin nhắn của dịch vụ Ngân hàng điện tử bị truy cập
            hoặc sử dụng bởi một bên không có thẩm quyền. Khách hàng đồng ý rằng Ngân hàng được miễn trách
            trong những trường hợp như thế này.
            <br>
            &nbsp;&nbsp;d) Đồng ý nhận tin nhắn do Viettel gửi tới để:
            <br>
            &nbsp;&nbsp;&nbsp;&nbsp;- Thông báo biến động số dư tài khoản trong trường hợp Khách hàng đăng ký sử dụng.
            <br>
            &nbsp;&nbsp;&nbsp;&nbsp;- Thông báo OTP (mật khẩu giao dịch điện tử).
            <br>
            &nbsp;&nbsp;&nbsp;&nbsp;- Thông báo các sản phẩm, dịch vụ mới, chương trình khuyến mại.
            <br>
            &nbsp;&nbsp;&nbsp;&nbsp;- Thông báo khác phục vụ cho việc thực hiện giao dịch điện tử với khách hàng.
            <br>
            2.5. Trong trường hợp thanh toán qua Ngân hàng điện tử, Khách hàng có thể sử dụng Dịch vụ theo nhu
            cầu của mình. Tuy nhiên, số tiền thanh toán phải đảm bảo không vượt quá hạn mức được phép sử dụng
            Dịch vụ và số dư tài khoản tiền gửi thanh toán của Khách hàng vào thời điểm thực hiện giao dịch, trừ
            trường hợp Khách hàng được Viettel cấp hạn mức thấu chi trên tài khoản này.
            </p>

            <p><strong>Điều 3. Mật khẩu, chữ ký điện tử sử dụng dịch vụ</strong>
            <br>
            3.1. Mật khẩu do Viettel cấp được sử dụng để định danh Khách hàng khi sử dụng Dịch vụ. Khách
            hàng phải thay đổi mật khẩu ngay lần đầu tiên sử dụng. Trong quá trình sử dụng Dịch vụ, Khách hàng
            nên định kỳ thay đổi mật khẩu.
            <br>
            3.2. Chữ ký điện tử là mã khóa bảo mật Viettel gửi cho Khách hàng để chứng thực quyền hạn và
            trách nhiệm của Khách hàng khi sử dụng Dịch vụ. Khi Khách hàng dùng chữ ký điện tử để thực hiện
            thanh toán thì chữ ký điện tử có giá trị như chữ ký tay trên chứng từ giấy.
            <br>
            3.3. Khách hàng phải có trách nhiệm bảo mật các tên truy cập, mật khẩu, chữ ký điện tử và các yếu tố
            định danh khác do Viettel cấp; sử dụng mọi biện pháp cần thiết để ngăn chặn việc sử dụng Dịch
            vụ bởi những người không có thẩm quyền. Để bảo vệ mật khẩu, tránh bị rơi, mất, nhầm lẫn... Khách hàng
            cần ghi nhớ chứ không nên lưu mật khẩu ra giấy, điện thoại, máy tính hoặc các thiết bị, phương tiện
            khác tương tự.
            <br>
            3.4. Khách hàng phải bảo vệ mật khẩu, chữ ký điện tử để đảm bảo rằng chỉ có Khách hàng mới có quyền
            sử dụng Dịch vụ. Mọi giao dịch thanh toán theo hóa đơn, chuyển khoản, nếu Viettel kiểm tra thấy
            đúng, đủ các yếu tố định danh theo quy định và cam kết trong Hợp đồng này, thì sẽ mặc nhiên coi đó
            là ý chí của Khách hàng, cho dù sau này phát hiện việc truy cập thông tin đó được thực hiện bởi người
            không có thẩm quyền; Khách hàng phải hoàn toàn chịu trách nhiệm về những rủi ro và thiệt hại do việc
            sử dụng trái phép đó gây ra.
            <br>
            3.5. Khách hàng phải thông báo ngay cho Viettel để kịp thời xử lý khi tên truy cập, mật khẩu, chữ
            ký điện tử và/ hoặc các yếu tố định danh khác bị mất, đánh cắp, bị lộ, hoặc nghi lộ; đồng thời Khách
            hàng phải chịu trách nhiệm về những thiệt hại, tổn thất và rủi ro khác trước khi thông báo cho
            Viettel.
            </p>

            <p><strong>Điều 4. Thời gian xử lý giao dịch</strong>
            <br>
            4.1. Thời gian xử lý các giao dịch điện tử do Khách hàng chủ động gửi yêu cầu:
            <br>
            &nbsp;&nbsp;a) Khách hàng được thực hiện giao dịch 24 giờ trong ngày và 07 ngày trong tuần.
            <br>
            &nbsp;&nbsp;b) Viettel sẽ gửi thông báo ngay cho Khách hàng ngay khi có yêu cầu từ phía Khách hàng. Trên
            thông báo giao dịch cuối kỳ, đối với những giao dịch nhận được sau thời gian chạy xử lý cuối ngày sẽ
            được hệ thống của Viettel coi là giao dịch của ngày tiếp theo.
            <br>
            4.2. Thời gian xử lý giao dịch điện tử nhắn tin, thông báo chủ động của Viettel tới Khách hàng.
            <br>
            &nbsp;&nbsp;a) Viettel sẽ gửi thông báo ngay cho Khách hàng khi có thay đổi về số dư trên tài khoản (áp dụng
            với các tài khoản khách hàng đăng ký sử dụng dịch vụ).
            <br>
            &nbsp;&nbsp;b) Đối với các giao dịch trả lãi tự động, thu nợ tự động và chuyển tiền tự động (AFT)… của Viettel
            đối với Khách hàng, Viettel sẽ gửi thông báo biến động tài khoản sau 7h sáng của ngày kế tiếp.
            </p>

            <p><strong>Điều 5. Quyền và trách nhiệm của Viettel</strong>
            <br>
            5.1. Viettel đảm bảo rằng hệ thống Dịch vụ chạy ổn định, an toàn và tuân thủ các quy định của
            pháp luật liên quan đến việc cung ứng các dịch vụ trực tuyến.
            <br>
            5.2. Viettel không chịu trách nhiệm đối với những thiệt hại, tổn thất của Khách hàng phát sinh
            trong quá trình sử dụng Dịch vụ, trừ phi những thiệt hại, tổn thất này là do lỗi cố ý của Viettel.
            <br>
            5.3. Viettel không chịu trách nhiệm đối với những thiệt hại trực tiếp hoặc gián tiếp mà Khách hàng
            phải chịu phát sinh từ hoặc do:
            <br>
            &nbsp;&nbsp;a) Việc sử dụng Dịch vụ hoặc tiếp cận các thông tin mà Dịch vụ cung ứng của những người được Khách
            hàng ủy quyền; hoặc
            <br>
            &nbsp;&nbsp;b) Việc Khách hàng để mất, mất cắp, lộ tên truy cập, mật khẩu, chữ ký điện tử và/ hoặc các yếu tố định
            danh khác mà Viettel cung cấp dẫn đến người khác dùng những thông tin này để sử dụng Dịch
            vụ hoặc tiếp cận những thông tin mà Dịch vụ cung ứng; hoặc
            <br>
            &nbsp;&nbsp;c) Bất kỳ sự chậm trễ nào trong việc gửi tin nhắn, hoặc Khách hàng không nhận được tin nhắn; hoặc
            <br>
            &nbsp;&nbsp;d) Tính toàn vẹn hoặc tính xác thực của tin nhắn được gửi cho Khách hàng; hoặc
            <br>
            &nbsp;&nbsp;e) Việc tin nhắn được thực hiện bởi một bên thứ ba mà người này, bằng bất cứ cách nào, thực hiện việc
            kết nối thiết bị của họ tới số điện thoại mà Khách hàng đã đăng ký; hoặc
            <br>
            &nbsp;&nbsp;f) Sự ngắt quãng, trì hoãn, chậm trễ, tình trạng không sẵn sàng sử dụng hoặc bất kỳ sự cố nào xảy ra
            trong quá trình cung cấp Dịch vụ do các nguyên nhân ngoài khả năng kiểm soát hợp lý của Viettel,
            bao gồm nhưng không giới hạn ở tình trạng gián đoạn do Dịch vụ cần được nâng cấp, sửa chữa; lỗi
            đường truyền của nhà cung cấp dịch vụ Internet; lỗi gián đoạn do nhà cung cấp dịch vụ thanh toán theo
            hóa đơn; hoặc
            <br>
            &nbsp;&nbsp;g) Bất cứ hành động bất khả kháng nào bao gồm nhưng không giới hạn bởi thiên tai, đình công, hoặc
            các yêu cầu hay chỉ thị của Chính phủ và các cơ quan nhà nước, người có thẩm quyền khác.
            <br>
            5.4. Viettel có quyền thay đổi, ngừng hoặc chấm dứt cung cấp Dịch vụ vào bất kỳ thời điểm nào
            mà không cần có sự đồng ý của Khách hàng. Tuy nhiên, Viettel có trách nhiệm thông báo trước
            cho Khách hàng về việc thay đổi, ngừng hoặc chấm dứt cung cấp Dịch vụ.
            </p>
        </div>
    </mat-card-content>
</mat-card>